export * from "./types.js";
export * from "./copy.js";
export {
  checkDefaultSuperInsurance,
  assertNoProductHandoff,
  assertNoPersonalisedDollar,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { DefaultSuperInsuranceRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of default-super-insurance rulesets by financial year. Historical
 * years stay registered so re-runs resolve against the right rules. */
export const DEFAULT_SUPER_INSURANCE_RULESETS: Record<
  string,
  DefaultSuperInsuranceRuleSet
> = {
  "2025-26": fy2025_26,
};

/** Resolve the default-super-insurance ruleset for a financial year, or throw. */
export function defaultSuperInsuranceRulesFor(
  fy: FinancialYear,
): DefaultSuperInsuranceRuleSet {
  const rules = DEFAULT_SUPER_INSURANCE_RULESETS[fy];
  if (!rules) {
    throw new Error(
      `no default-super-insurance ruleset registered for FY ${fy}`,
    );
  }
  return rules;
}

/** Most recent default-super-insurance ruleset — the default for "this year". */
export const DEFAULT_SUPER_INSURANCE_CURRENT_FY: FinancialYear = "2025-26";
